<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="notice-container" style="height: 100%; position: relative">
    <notice />
  </div>
</template>

<script>
export default {
  name: 'Notice',
  components: {
    notice: () => import('@/views/ita/components/noticeCcomponents.vue'),
  },
  data() {
    return {
      list: [],
    }
  },
  created() {},
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.app-main {
  position: absolute !important;
  height: 100%;
}
</style>
